(function() {
  var ANNOTATION_ID = 'zp-annually-per-month';

  function parsePrice(text) {
    // Extract numeric portion, handling both comma and dot decimal separators
    // e.g. "Annually - €119,00 EUR" or "Annually - €119.00 EUR"
    var numericStr = text.replace(/[^0-9,.]/g, '').trim();
    // If ends with comma + 2 digits, comma is the decimal separator
    if (/,\d{2}$/.test(numericStr)) {
      return parseFloat(numericStr.replace(/\./g, '').replace(',', '.'));
    }
    return parseFloat(numericStr.replace(/,/g, ''));
  }

  function getCurrencySymbol(text) {
    // Strip digits, commas, dots, whitespace and known currency codes
    var sym = text.replace(/[0-9,.\s]/g, '').replace(/EUR|USD|GBP|AUD|NZD|CAD/g, '').trim();
    return sym || '€';
  }

  function formatPrice(num, useCommaDecimal) {
    var formatted = num.toFixed(2);
    return useCommaDecimal ? formatted.replace('.', ',') : formatted;
  }

  function removeAnnotation() {
    var el = document.getElementById(ANNOTATION_ID);
    if (el) el.parentNode.removeChild(el);
  }

  function updatePriceAnnotation() {
    // Find the Zipify hidden select (has data-productid attribute)
    var select = document.querySelector('select[data-productid]');
    if (!select) return;

    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    var selectedText = selectedOption.text || '';

    // Remove any existing annotation first
    removeAnnotation();

    // Only proceed if Annually is selected
    if (selectedText.toLowerCase().indexOf('annually') === -1) return;

    // Find annual and monthly prices from the select options
    var annuallyText = '';
    var monthlyText = '';
    for (var i = 0; i < select.options.length; i++) {
      var optText = select.options[i].text;
      if (optText.toLowerCase().indexOf('annually') !== -1) annuallyText = optText;
      if (optText.toLowerCase().indexOf('monthly') !== -1) monthlyText = optText;
    }

    if (!annuallyText) return;

    var annualPrice = parsePrice(annuallyText);
    if (isNaN(annualPrice) || annualPrice <= 0) return;

    var monthlyRateRaw = annualPrice / 12;

    // Determine decimal separator from the price string
    var useCommaDecimal = /,\d{2}/.test(annuallyText);
    var currencySymbol = getCurrencySymbol(annuallyText);
    var monthlyRate = formatPrice(monthlyRateRaw, useCommaDecimal);

    // Find the price display element
    var priceEl = document.querySelector('[data-price-element]');
    if (!priceEl) return;

    // Create annotation element
    var annotation = document.createElement('div');
    annotation.id = ANNOTATION_ID;
    annotation.style.cssText = [
      'font-size: 1em',
      'opacity: 0.85',
      'margin-top: 4px',
      'line-height: 1.3',
      'font-weight: normal'
    ].join(';');
    annotation.textContent = (currencySymbol + monthlyRate + ' per month').replace(/-/g, ' - ');

    // Insert immediately after the price element
    if (priceEl.nextSibling) {
      priceEl.parentNode.insertBefore(annotation, priceEl.nextSibling);
    } else {
      priceEl.parentNode.appendChild(annotation);
    }
  }

  function bindEvents() {
    // Listen for Zipify radio button changes
    document.addEventListener('change', function(e) {
      var target = e.target;
      if (!target) return;
      if (
        target.hasAttribute('data-zp-option-input') ||
        target.hasAttribute('data-productid')
      ) {
        // Small delay to allow Zipify to update the hidden select value
        setTimeout(updatePriceAnnotation, 150);
      }
    });
  }

  function init() {
    // Only run on pages that have Zipify product elements
    if (!document.querySelector('[data-options-selector]') && !document.querySelector('select[data-productid]')) {
      return;
    }
    bindEvents();
    updatePriceAnnotation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
